import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'

import WelcomePage from './views/user/Welcome'
const PlanPage = () => import(/* webpackChunkName: "plan" */ './views/user/Plan')
const DashboardReportsPage = () => import(/* webpackChunkName: "reports" */ './views/manager/Dashboard')
const PeriodReportsPage = () => import(/* webpackChunkName: "reports" */ './views/manager/Reports')
const TeacherReportPage = () => import(/* webpackChunkName: "reports" */ './views/manager/TeacherReport')
const TeacherDepartmentReportPage = () => import(/* webpackChunkName: "reports" */ './views/manager/TeacherDepartmentReport')
const DepartmentReportPage = () => import(/* webpackChunkName: "reports" */ './views/manager/DepartmentReport')
const ReportsDepartmentSummaryPage = () => import(/* webpackChunkName: "reports" */ './views/manager/summary/Department')
const ReportsTeachersSummaryPage = () => import(/* webpackChunkName: "reports" */ './views/manager/summary/Teachers')
const ReportsNotCountedPage = () => import(/* webpackChunkName: "reports" */ './views/manager/reports/NotCounted')

import Menu from './menu/Default'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: {
        name: 'welcome'
      },
      components: {
        default: Home,
        menu: Menu
      },
      children: [
        {
          path: 'welcome',
          name: 'welcome',
          component: WelcomePage
        },
        {
          path: 'plan/:period',
          name: 'plan',
          component: PlanPage
        }
      ]
    },
    {
      path: '/reports',
      name: 'reports',
      components: {
        default: DashboardReportsPage,
        menu: () => import(/* webpackChunkName: "reports" */ './menu/Manager')
      },
      children: [
        {
          path: ':period',
          name: 'periodReports',
          component: PeriodReportsPage,
          // redirect: {
          //   name: 'teacherReport'
          // },
          children: [
            {
              path: 'teachers',
              name: 'teacherReport',
              component: TeacherReportPage
            },
            {
              path: 'department-teachers',
              name: 'teacherReportByDepartment',
              component: TeacherDepartmentReportPage
            },
            {
              path: 'departments',
              name: 'departmentReport',
              component: DepartmentReportPage
            },

            // summary
            {
              path: 'department-summary',
              name: 'reportsDepartmentSummary',
              component: ReportsDepartmentSummaryPage
            },
            {
              path: 'teachers-summary',
              name: 'reportsTeachersSummary',
              component: ReportsTeachersSummaryPage
            },

            // not-counted
            {
              path: 'not-counted',
              name: 'reportsNonCounted',
              component: ReportsNotCountedPage
            },
          ]
        }
      ]
    },
    {
      path: '/settings',
      name: 'config',
      redirect: {
        name: 'configCommon'
      },
      components: {
        default: () => import(/* webpackChunkName: "config" */ './views/config/Default'),
        menu: () => import(/* webpackChunkName: "config" */ './menu/Config')
      },
       children: [
         {
           path: '',
           name: 'configCommon',
           component: () => import(/* webpackChunkName: "config" */ './views/config/Common')
         },
         {
           path: 'roles',
           name: 'configRoles',
           component: () => import(/* webpackChunkName: "config" */ './views/config/Roles')
         },
         {
           path: 'users',
           name: 'configUsers',
           component: () => import(/* webpackChunkName: "config" */ './views/config/Users')
         }
       ]
    },
    {
      path: '/admin',
      name: 'admin',
      redirect: {
        name: 'adminDashboard'
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        default: () => import(/* webpackChunkName: "admin" */ './views/Admin'),
        menu: () => import(/* webpackChunkName: "admin" */ './menu/Admin')
      },
      children: [
        {
          path: 'dashboard',
          name: 'adminDashboard',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/Dashboard')
        },
        {
          path: 'periods',
          name: 'adminPeriods',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/Periods')
        },
        {
          path: 'institutions',
          name: 'adminInstitutions',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/Institutions')
        },
        {
          path: 'departments',
          name: 'adminDepartments',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/Departments')
        },
        {
          path: 'teachers',
          name: 'adminTeachers',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/Teachers')
        },
        {
          path: 'indicators',
          name: 'adminIndicators',
          component: () => import(/* webpackChunkName: "admin" */ './views/admin/Indicators')
        }
      ]
    }
  ]
})
